<template>
  <div class="buttons-cta">
    <button class="buttons-cta-explore" @click="$emit('clickFunctionExplore')">
      {{ label }}
    </button>
    <!-- <button
      class="buttons-cta-download"
      @click="$emit('clickFunctionDownload')"
    >
      <svgicon
        class="buttons-cta-download__icon"
        name="download"
        width="1rem"
        height="1rem"
        color="var(--ui-white)"
      ></svgicon>
      {{ labelSB }}
    </button> -->
  </div>
</template>

<script>
export default {
  name: "CtaButton",
  props: {
    label: {
      type: String,
      required: false,
    },
    labelSB: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.buttons-cta {
  &-explore {
    width: 49.06vw;
    height: 7.05vh;
    border-radius: toRem(6);
    color: $gray_01;
    @include link-M;
    text-transform: uppercase;
    background-color: $primary-yellow;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &-download {
    @extend .buttons-cta-explore;
    margin-top: toRem(11);
    color: $ui-white;
    background-color: $white_02;

    &__icon {
      margin-right: toRem(8);
    }
  }
}

.tablet {
  .buttons-cta {
    &-explore {
      @include link-L;
      height: 5.08vh;
      width: 33.83vw;
    }
  }
}
</style>
